import { CityState } from './types';

export class DistrictEngine {
  /**
   * Recalculates spatial land values based on park boosts and industrial penalties.
   */
  public tickDistricts(state: CityState) {
    const parcels = state.parcels;
    const buildings = state.buildings;

    const parks: { x: number; y: number }[] = [];
    const industries: { x: number; y: number }[] = [];
    const commercial: { x: number; y: number }[] = [];

    // Identify value buffers
    for (const key of Object.keys(buildings)) {
      const b = buildings[key];
      if (b.stage === 'completed') {
        if (b.zone === 'park' || b.zone === 'civic') {
          parks.push({ x: b.x, y: b.y });
        } else if (b.zone === 'industrial') {
          industries.push({ x: b.x, y: b.y });
        } else if (b.zone === 'commercial') {
          commercial.push({ x: b.x, y: b.y });
        }
      }
    }

    // Update land value metrics
    for (const key of Object.keys(parcels)) {
      const p = parcels[key];
      let value = 100; // standard baseline

      // 1. Park boost (decays with Manhattan distance)
      for (const park of parks) {
        const dist = Math.abs(p.x - park.x) + Math.abs(p.y - park.y);
        if (dist <= 5) {
          value += (6 - dist) * 20; // adjacent gets +100
        }
      }

      // 2. Industrial penalty
      for (const ind of industries) {
        const dist = Math.abs(p.x - ind.x) + Math.abs(p.y - ind.y);
        if (dist <= 4) {
          value -= (5 - dist) * 15; // adjacent gets -60
        }
      }

      // 3. Commercial convenience
      for (const com of commercial) {
        const dist = Math.abs(p.x - com.x) + Math.abs(p.y - com.y);
        if (dist <= 3) {
          value += (4 - dist) * 8;
        }
      }

      p.landValue = Math.max(10, Math.round(value));

      // sync with active building on parcel
      if (p.buildingId && buildings[key]) {
        buildings[key].landValue = p.landValue;
      }
    }
  }
}
